import { StorageItem } from '@uploadcam/common';
import { StorageListPage } from './list-page';

export class MockListPage implements StorageListPage {
  constructor(private readonly items: StorageItem[]) {}

  public getItems(): StorageItem[] {
    return this.items;
  }

  public hasNext(): boolean {
    return false;
  }

  public async getNext(): Promise<StorageListPage> {
    throw new Error('Next page requested for the last page.');
  }
}
